import React from 'react';
import { Link } from 'react-router-dom';
import s from './Slider.scss';

const SlideContainer = ({ link, slideClasses, children }) => (
	link ? <Link to={`/${link}`} className={slideClasses.join(' ')}>{ children }</Link> : <div className={slideClasses.join(' ')}>{ children }</div>
);

const Slide = ({ isActive, color, image, imageWidth, imageHeight, link, position, text, win }) => {
	const slideClasses = [s.slide, s[`slide__${color}`]];
	const slideTextClasses = [s.slide_text];
	const styles = {};

	if (isActive) slideClasses.push(s.slide__active);
	position.forEach(pos => slideTextClasses.push(s[`slide_text__${pos}`]));

	if (win) {
		const imageRatio = imageWidth / imageHeight;
		const winRatio = win.width / win.height;

		if (imageRatio < winRatio) {
			styles.width = `${win.width}px`;
			styles.height = `${Math.round(win.width / imageRatio)}px`;
		} else {
			styles.width = `${Math.round(win.height * imageRatio)}px`;
			styles.height = `${win.height}px`;
		}
	}

	return (
		<SlideContainer link={link} slideClasses={slideClasses}>
			<img className={s.slide_media} src={image} alt="" style={styles} />
			<div className={slideTextClasses.join(' ')} dangerouslySetInnerHTML={{ __html: text }} />
		</SlideContainer>
	);
};

export default Slide;



// WEBPACK FOOTER //
// ./components/Slider/Slide.jsx